import React, { createContext, useContext, ReactNode } from 'react';
import { supabase } from '../lib/supabase';
import { SupabaseClient } from '@supabase/supabase-js';

// Create a context for the Supabase client
interface SupabaseContextType {
  supabase: SupabaseClient;
}

const SupabaseContext = createContext<SupabaseContextType | undefined>(undefined);

// Provider component that wraps your app and makes Supabase client available to any child component
export const SupabaseProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <SupabaseContext.Provider value={{ supabase }}>
      {children}
    </SupabaseContext.Provider>
  );
};

// Hook to use the Supabase context
export const useSupabase = () => {
  const context = useContext(SupabaseContext);
  if (!context) {
    throw new Error('useSupabase must be used within a SupabaseProvider');
  }
  return context;
}; 